import React from 'react';
import { motion } from 'framer-motion';
import { ApplyButton } from './ApplyButton';
export function HeroSection() {
  return <section className="relative min-h-screen flex flex-col items-center justify-center px-6 py-24 bg-gradient-to-b from-cream via-cream to-cream-light overflow-hidden" data-id="element-31">
      {/* Subtle Organic Background Shapes — slate tones */}
      <div className="absolute top-1/4 -left-20 w-96 h-96 bg-slate/5 blur-3xl rounded-full mix-blend-multiply animate-pulse" style={{
      animationDuration: '8s'
    }} data-id="element-32" />
      <div className="absolute bottom-1/4 -right-20 w-[30rem] h-[30rem] bg-slate/5 blur-3xl rounded-full mix-blend-multiply animate-pulse" style={{
      animationDuration: '10s',
      animationDelay: '1s'
    }} data-id="element-33" />

      {/* Central Organic Blob — very subtle */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[40rem] h-[40rem] border border-slate/5 blob-shape-1 opacity-40 pointer-events-none" data-id="element-34" />

      <div className="max-w-4xl mx-auto text-center z-10 relative" data-id="element-35">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1.2,
        delay: 0.2,
        ease: 'easeOut'
      }} data-id="element-36">
          <span className="block font-sans text-xs tracking-wide-editorial uppercase text-slate/60 mb-8 border-b border-slate/20 pb-2 inline-block" data-id="element-37">
            The Omnipreneur Incubator
          </span>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1.4,
        delay: 0.4,
        ease: 'easeOut'
      }} className="font-serif font-light text-5xl md:text-7xl lg:text-8xl text-ink leading-[1] tracking-tight mb-10" data-id="element-38">
          Build a Business That Grows
          <span className="block italic mt-2 text-slate" data-id="element-39">
            With You, Not Against You
          </span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 1.4,
        delay: 0.8
      }} className="font-sans text-slate text-lg md:text-xl max-w-2xl mx-auto leading-relaxed mb-16 tracking-wide font-light" data-id="element-40">
          For established women entrepreneurs ready to scale without the chaos.
          Realign your leadership, stabilize your foundation, and expand with
          coherence in 12 weeks.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1.2,
        delay: 1
      }} data-id="element-41">
          <ApplyButton data-id="element-42" />
        </motion.div>
      </div>

      {/* Editorial bottom rule */}
      <div className="absolute bottom-0 left-0 w-full h-px bg-ink/10" data-id="element-43" />
    </section>;
}